<template>
  <div
    class="relative z-10 mx-4 w-full overflow-hidden rounded-xl border-l-[12px] border-blue bg-white px-4 py-6 shadow-[0_0_84px_0_rgba(0,180,210,0.23)] lg:mx-0 lg:mt-0 lg:max-w-[600px] lg:rounded-2xl lg:border-l-[16px] lg:p-9"
  >
    <SubTitle v-if="subTitle" class="text-black lg:text-xl lg:leading-none">
      {{ subTitle }}
    </SubTitle>
    <Title v-if="title" custom-style="uppercase lg:!text-5xl lg:!leading-none">{{ title }}</Title>
    <div
      class="mt-4 !hidden space-y-4 font-sans text-base lg:line-clamp-4 lg:!block lg:max-w-lg lg:text-lg"
      v-html="content"
    ></div>
    <div
      v-if="contentSecondary"
      class="mt-4 line-clamp-4 space-y-4 font-sans text-base lg:!hidden lg:text-lg"
      v-html="contentSecondary"
    />

    <slot v-if="formComponent" name="default" :form-component="formComponent"></slot>

    <Link
      v-if="link?.url || link?.title"
      :title="link?.title"
      color="pink"
      class="mt-8 w-full lg:w-auto"
      :link="removeCmsDomain(link?.url)"
      :external="link.type === 'ext'"
    />
  </div>
</template>

<script setup lang="ts">
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import Link from '../atoms/Link.vue'
import type { ILinkData } from '../../types'
import { removeCmsDomain } from '../../utils/urlFilter'

type Props = {
  subTitle?: string
  title?: string
  content?: string
  contentSecondary?: string
  link?: ILinkData
  formComponent?: object
}
defineProps<Props>()
</script>
